<template>
    <div v-if="news_" class="main" data-temp="single">
        <section
                class="sectionNewsPost post-50 post type-post status-publish format-standard has-post-thumbnail hentry category-uncategorized"
                data-temp="template_parts-content-post">
            <div class="containerWrapper">
                <div class="container">
                    <div class="back2NewsLinkWrapper">
                        <router-link class="back2NewsLink" :to="{path: newsLink}" :key="newsLink" title="Back to news">
                            Back to news
                        </router-link>
                    </div>

                    <div class="headlineWrapper">
                        <h1 v-html="news_.title.rendered" class="headline headline-h1">

                        </h1>
                    </div>

                    <div v-html="news_.content.rendered" class="content">

                    </div>

                    <div class="back2NewsLinkWrapper">
                        <router-link class="back2NewsLink" :to="{path: newsLink}" title="Back to news">
                            Back to news
                        </router-link>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {menusNames as mn, menuProps as mp} from "../constants/menus";

    export default {
        computed: {
            ...mapState({
                news_: state => state.news.news_,
                newsLink: (state, getters) => {
                    return getters['routes/getProp'](mn.NEWS, mp.LINK)
                }
            }),
        },
        created() {
            console.log('news-detail: created')
            if (!this.news_) {
                this.get()
            }
        },
        mounted() {
        },
        methods: {
            async get() {
                this.loading = true

                try {
                    await this.$store.dispatch('news/getPost', {slug: this.$route.params.detail})
                } catch (e) {

                }
                this.loading = false
            },
        }
    }
</script>

<style>
    .wrapper-news .sectionNewsPost .content img {
        height: auto;
    }
</style>
